/*
 Widget containers that Algolia will target to generate its
 UI inside. If this element does not exist, the widget will
 fail and the entire UI will not load at this time.
 */

export const containers = {
    searchBox:                  "[data-products-search]",
    results:                    "[data-products-results]",
    clearRefinements:           "[data-products-clear-refinements]",
    currentRefinements:         "[data-products-current-refinements]",
    engineManufacturer:         "[data-widget='engineManufacturer']",
    brands:                     "[data-widget='brands']",
    cycle:                      "[data-widget='cycle']",
    cylinders:                  "[data-widget='cylinders']",
    displacementCubicInches:    "[data-widget='displacementCubicInches']",
    displacementLiters:         "[data-widget='displacementLiters']",
    dryWeight:                  "[data-widget='dryWeight']",
    emissionsUs:                "[data-widget='emissionsUs']",
    emissionsEu:                "[data-widget='emissionsEu']",


    engineRating:               "[data-widget='engineRating']",
    engineSeries:               "[data-widget='engineSeries']",
    frequency:                  "[data-widget='frequency']",
    maxTorqueLbFt:              "[data-widget='maxTorqueLbFt']",
    maxTorqueLbNm:              "[data-widget='maxTorqueLbNm']",
    powerRatingHp:              "[data-widget='powerRatingHp']",
    powerRatingKva:             "[data-widget='powerRatingKva']",
    powerRatingKw:              "[data-widget='powerRatingKw']",
    productType:                "[data-widget='productType']",
    speedRating:                "[data-widget='speedRating']",
}
